import { useTelegram } from '@st/telegram/composables/useTelegram'
import { useAllowedAssets } from '../composables/useAllowedAssets'
import { usePaymentsDeps } from '../useDeps'

export default defineNuxtPlugin({
  name: 'tmaCurrenciesUpdate',
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore payments have no idea about site plugins
  dependsOn: ['paymentsDeps'],
  async setup() {
    const { isAuthenticated, isJustRegisteredUser } = usePaymentsDeps()
    const { setPreferredCurrencyAllowedForTMA } = useAllowedAssets()
    const { isTelegramMiniApp } = useTelegram()

    watchEffect(() => {
      if (!isTelegramMiniApp.value || !isAuthenticated.value) return
      setPreferredCurrencyAllowedForTMA({
        isSignUp: isJustRegisteredUser.value,
      })
      isJustRegisteredUser.value = false
    })
  },
})
